import React, { Component } from "react";
import { auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

class AddToGroupBtn extends Component {
  constructor(props) {
    super(props);

    this.addUserToGroup = this.addUserToGroup.bind(this);

    this.state = {
      selectedMembers: [],
    };
  }

  addUserToGroup() {
    customLog(this.props.data);
    const data = this.props.data;
    const { dataCallBack } = this.props;

    const memberDetails = {
      memberEmail: data.memberEmail,
      // uid: data.uid,
    };
    this.setState(
      {
        // selectedMembers: [...this.state.selectedMembers, memberDetails],
        selectedMembers: [memberDetails],
      },
      () => {
        dataCallBack(this.state.selectedMembers);
      }
    );
  }
  render() {
    // console.log(this.props);
    return (
      <div>
        <button
          className={"select-btn"}
          // disabled={
          //   this.props.data.isSuperAdmin ||
          // this.props.data.memberEmail === auth.currentUser.email
          // }
          onClick={this.addUserToGroup}
        >
          &#43;
        </button>
      </div>
    );
  }
}

export default AddToGroupBtn;
